import * as yup from "yup";
import { toast } from "react-toastify";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const internSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  city: yup.string().required("City is Required"),
  email: yup
    .string()
    .email("Please enter a valid email")
    .required("Email is required"),
  phNumber: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("Phone Number is Required"),
  about: yup
    .string()
    .max(500, "Please Shorten the summary")
    .required("Please enter a short summary of the issue"),
  internshipType: yup
    .mixed()
    .required("Please Select One")
    .oneOf(["Online Internship", "Offline Internship"], "Enter Valid Data"),
});

export const initialValues = {
  name: "",
  city: "",
  email: "",
  phNumber: "",
  about: "",
  internshipType: "",
  file: "",
};

export const errorNotify = (errorMessage) => {
  toast.error(errorMessage, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

export const notify = () =>
  toast.success("Request Successful", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });

export default internSchema;
